module.exports = __webpack_public_path__ + "static/media/phone.6ff9bdfc.svg";